import React from 'react';

const Ribbon = ({ text, customStyle }) => {
  return (
    <span style={customStyle}>{text}</span>
  );
};

export default Ribbon;
